import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';
export var typeMessage = function typeMessage(props) {
  var path = props.title ? 'rules.type' : 'rules.reg';
  return substitute(getLocale(path), props);
};
var options = {
  skipUndefined: true
};
export default (function (type) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      message = _ref.message,
      tip = _ref.tip;

  return function (msg) {
    return deepMerge({
      type: type,
      message: typeMessage
    }, deepMerge({
      message: message,
      tip: tip
    }, {
      message: msg
    }, options), options);
  };
});